import Vue from 'vue'

const luDepartmentStrategy = {
  state: {
    luDepartmentStrategy: [],
    selectedLuDepartmentStrategy: {},
  },

  getters: {
    luDepartmentStrategy(state) {
      return state.luDepartmentStrategy
    },
    selectedLuDepartmentStrategy(state) {
      return state.selectedLuDepartmentStrategy
    },
  },

  mutations: {
    luDepartmentStrategy(state, payload) {
      state.luDepartmentStrategy = payload
    },
    selectedLuDepartmentStrategy(state, payload) {
      state.selectedLuDepartmentStrategy = JSON.parse(JSON.stringify(payload))
    },
  },

  actions: {
    setSelectedLuDepartmentStrategy(context, payload) {
      context.commit('selectedLuDepartmentStrategy', payload)
    },
    loadLuDepartmentStrategy(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'LuDepartmentStrategy'
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('luDepartmentStrategy', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    loadSelectedLuDepartmentStrategy(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'LuDepartmentStrategy/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedLuDepartmentStrategy', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    updateLuDepartmentStrategy(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuDepartmentStrategy/${payload.ID}`
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'department strategy updated'},
              {root: true}
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuDepartmentStrategy')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    createLuDepartmentStrategy(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuDepartmentStrategy`
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'department strategy created'},
              {root: true}
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuDepartmentStrategy')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    saveLuDepartmentStrategy(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateLuDepartmentStrategy', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createLuDepartmentStrategy', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteLuDepartmentStrategy(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuDepartmentStrategy/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'department strategy deleted'},
              {root: true}
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuDepartmentStrategy')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
  },
}

export default luDepartmentStrategy
